import { Box } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { useMemo, useState } from 'react'
import { Sidebar, PageTransition, AppErrorBoundary } from '@components/index'
import { MobileNavContext } from '@hooks/useMobileNav'
import { ROUTES } from '@routes/paths'

export const DashboardLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()

  const navValue = useMemo(() => ({ openMobileNav: () => setMobileOpen(true) }), [])

  return (
    <MobileNavContext.Provider value={navValue}>
      <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
        <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            p: { xs: 2, md: 3 },
          }}
        >
          <Box
            sx={(theme) => ({
              flex: 1,
              borderRadius: 4,
              bgcolor: 'background.paper',
              p: { xs: 2, md: 3.5 },
              border: `1px solid ${theme.palette.divider}`,
            })}
          >
            <AppErrorBoundary onReset={() => window.location.assign(ROUTES.dashboard)}>
              <AnimatePresence mode="wait">
                <PageTransition key={location.pathname}>
                  <Outlet />
                </PageTransition>
              </AnimatePresence>
            </AppErrorBoundary>
          </Box>
        </Box>
      </Box>
    </MobileNavContext.Provider>
  )
}
